export enum OfficeLocation {
  ST_LOUIS,
  DENVER,
}
